<template>
  <div class="e-progress">
    <div
      v-if="loading"
      class="mdl-progress mdl-js-progress mdl-progress__indeterminate"
      :style="blockStyle"
    >
      <div class="progressbar bar bar1" style="width: 0%;"></div>
      <div class="bufferbar bar bar2" style="width: 100%;"></div>
      <div class="auxbar bar bar3" style="width: 0%;"></div>
    </div>
    <div
      v-else
      :style="blockStyle"
    ></div>
  </div>
</template>

<script>
  export default {
    name: 'e-progress',
    data () {
      return {
        height: '5px'
      }
    },
    props: {
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      blockStyle () {
        return {
          height: this.height,
          width: '100%',
          display: 'block'
        }
      }
    }
  }
</script>
